<template>
  <div id="app">
    <main>
      <router-view v-wechat-title="$route.meta.title"></router-view>
    </main>
  </div>
</template>

<script>

export default {
  name: 'app',
  mounted() {
    this.fnResize()
    var self = this
    window.onresize = function () {
      self.fnResize()
    }
  },
  methods: {
    fnResize: function() {
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth
      if (deviceWidth >= 750) {
        deviceWidth = 750
        $('body,#app,main').css('height','100%')
      }else {
        $('body,#app,main').css('height','100%')
      }
      if (deviceWidth <= 320) {
        deviceWidth = 320
      }
      document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?eb638f86